var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isFontAwesomeIcon)?_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":_vm.icon,"fixed-width":""}}):_c('i',{staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.icon)}})
}
var staticRenderFns = []

export { render, staticRenderFns }